import getLang from 'I18n/utils/getLang';
export const useLocalizedLanguageLinks = () => {
  const lang = getLang();
  const domain = window.location.hostname;
  const root = lang === 'ja' ? `https://www.hubspot.jp` : lang === 'pt' ? `https://br.hubspot.com` : ['es', 'fr', 'de'].includes(lang) ? `https://www.hubspot.${lang}` : undefined;
  return {
    homepageLink: root,
    demoLink: root ? `${root}/products/customer-platform/demo?hubs_signup-url=${root}/products/customer-platform/demo&hubs_signup-cta=login-demo-existing` : `https://offers.hubspot.com/crm-platform-demo?hubs_signup-url=${domain}/login&hubs_signup-cta=login-demo-existing`,
    buyLink: root ? `${root}/buy-starter-platform?hubs_content=app.hubspot.com/login&hubs_content-cta=login-starter-existing` : /* eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils */
    'https://www.hubspot.com/buy-starter-platform?hubs_content=app.hubspot.com/login&hubs_content-cta=login-starter-existing'
  };
};